import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { GithubIssueService } from "../../models/integrations/github-issue.service";

@Component({
  selector: "ab-github-integration",
  templateUrl: "./github.component.html",
})
export class GithubIntegrationComponent implements OnInit {
  @Input() public fields: any;
  @Input() public notice: any;

  public loading: boolean;
  public issue: any;
  public creatingIssue: boolean;
  public error: any;
  public removingIssue: boolean;

  constructor(private githubIssueService: GithubIssueService) {}

  public ngOnInit() {
    this.loading = true;

    return this.githubIssueService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((issue: any) => {
        this.issue = issue;
      });
  }

  public createIssue() {
    this.issue = { notice: this.notice };

    this.creatingIssue = true;
    this.githubIssueService
      .create(this.issue)
      .pipe(
        finalize(() => {
          delete this.creatingIssue;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeIssue() {
    this.issue = { notice: this.notice };

    this.removingIssue = true;
    return this.githubIssueService
      .destroy(this.issue)
      .pipe(
        finalize(() => {
          delete this.removingIssue;
        }),
      )
      .subscribe(() => {
        delete this.issue;
      });
  }
}
